export default __webpack_public_path__ + "static/media/title-sub.4a6d3032.png";